'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Converts a string to boolean
 * @param {*} str - The value to convert
 * @returns {boolean} The boolean value
 */
function convertStrToBool(str) {
    if (typeof str !== 'string') {
        return Boolean(str);
    }
    try {
        var obj = JSON.parse(str.toLowerCase());
        return obj == true;
    } catch (e) {
        return str != '';
    }
}

module.exports = {
    appendToUrl: appendToUrl,
    convertStrToBool: convertStrToBool
};
